// js
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import classnames from 'classnames';
// css
import '../../styles/components/common/Tooltip.scss';


class Tooltip extends Component {

  componentWillUnmount(){
    this.removeTooltip();
  }

  showTooltip() {
    const node = ReactDOM.findDOMNode(this); // eslint-disable-line react/no-find-dom-node

    if (node && !this.tooltip && this.props.text) {
      this.tooltip = document.createElement('div');
      document.body.appendChild(this.tooltip);
      ReactDOM.render(this.renderTooltip(this.props), this.tooltip);
      this.positionTooltip();
    }
  }

  positionTooltip() {
    const tooltip = this.tooltip;
    const node = ReactDOM.findDOMNode(this); // eslint-disable-line react/no-find-dom-node
    const targetRect = node.children[0].getBoundingClientRect();
    const tooltipRect = tooltip.children[0].children[0].getBoundingClientRect();

    tooltip.style.position = 'fixed';

    switch (this.props.position) {
      case 'right':
        tooltip.style.top = (targetRect.top - (tooltipRect.height - 24) / 2) + 'px';
        tooltip.style.left = (targetRect.left + targetRect.width) + 'px';
        break;
      case 'left':
        tooltip.style.top = (targetRect.top - (tooltipRect.height - 24) / 2) + 'px';
        tooltip.style.left = (targetRect.left - tooltipRect.width - 8) + 'px';
        break;
      case 'top':
        tooltip.style.top = (targetRect.top - tooltipRect.height - 10) + 'px';
        tooltip.style.left = targetRect.left + ((targetRect.width - tooltipRect.width) / 2) + 'px';
        break;
    }
  }

  removeTooltip() {
    if (this.tooltip) {
      ReactDOM.unmountComponentAtNode(this.tooltip);
      document.body.removeChild(this.tooltip);
      this.tooltip = null;
    }
  }

  renderTooltip(props) {
    const classNames = classnames([
      'tooltip',
      `tooltip-${props.position}`,
      props.className
    ]);

    return (
      <div className={classNames} role='tooltip'>
        <div className='tooltip-inner'>
          {props.text}
        </div>
      </div>
    );
  }

  render() {
    return (
      <div
        className='tooltip-indicator'
        onMouseEnter={() => this.showTooltip()}
        onMouseLeave={() => this.removeTooltip()}
      >
        {this.props.children}
      </div>
    );
  }
}

Tooltip.propTypes = {
  text: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.string
  ]),
  position: PropTypes.string,
  children: PropTypes.object
};

Tooltip.defaultProps = {
  position: 'right'
};

export default Tooltip;



// WEBPACK FOOTER //
// ./src/components/common/Tooltip.js